var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_607_2839)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.4924 8.6497C16.4924 7.99419 16.4379 7.51584 16.3201 7.01978H8.65936V9.97843H13.156C13.0654 10.7137 12.5759 11.821 11.4879 12.5651L11.4727 12.6641L13.8949 14.4976L14.0627 14.5139C15.6039 13.1232 16.4924 11.0769 16.4924 8.6497Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.65936 16.445C10.8624 16.445 12.7118 15.7363 14.0627 14.5139L11.4879 12.565C10.7989 13.0345 9.87418 13.3623 8.65936 13.3623C6.50168 13.3623 4.67036 11.9716 4.01755 10.0493L3.92186 10.0573L1.40324 11.9618L1.3703 12.0513C2.71205 14.6556 5.46811 16.445 8.65936 16.445Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.01756 10.0494C3.84531 9.5533 3.74563 9.02176 3.74563 8.47257C3.74563 7.92332 3.84531 7.39184 4.0085 6.89577L4.00394 6.79013L1.45375 4.85498L1.37031 4.89376C0.817313 5.97449 0.5 7.18811 0.5 8.47257C0.5 9.75703 0.817313 10.9706 1.37031 12.0513L4.01756 10.0494Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.65936 3.58269C10.1915 3.58269 11.225 4.22934 11.8143 4.76974L14.1171 2.57285C12.7028 1.2884 10.8624 0.5 8.65936 0.5C5.46811 0.5 2.71205 2.28937 1.3703 4.89371L4.00849 6.89573C4.67036 4.97347 6.50168 3.58269 8.65936 3.58269Z",
    fill: "#EB4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_607_2839"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmail);
export default __webpack_public_path__ + "static/media/Gmail.46c19789989d49b5eecd4d8349e8d73f.svg";
export { ForwardRef as ReactComponent };